import {Mapper} from '@s-ui/domain'

export class SeoInsuranceMetaInformationMapper extends Mapper {
  constructor({config, seoDataValueObjectFactory, seoDataMapper}) {
    super()

    this._config = config
    this._seoDataValueObjectFactory = seoDataValueObjectFactory
    this._seoDataMapper = seoDataMapper
  }

  async map({culture}) {
    const {insurance: insuranceConfig} = this._config.get('seo')

    const {CANONICAL, TITLE, META_DESCRIPTION, META_ROBOTS} = insuranceConfig[culture]

    const {links, metas, scripts, title} = this._seoDataMapper
      .title(TITLE)
      .description(META_DESCRIPTION)
      .robots(META_ROBOTS)
      .canonical(CANONICAL)
      .setOpenGraphData({
        title: TITLE,
        description: META_DESCRIPTION,
        url: CANONICAL
      })
      .setTwitterCardsData()
      .map()

    return this._seoDataValueObjectFactory({
      head: {
        link: links,
        meta: metas,
        scripts,
        title
      }
    })
  }
}
